import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray";
var _excluded = ["columns", "children"],
    _excluded2 = ["children", "columns", "gutter"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { Box } from '@miro-site/core';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";

var calculateGutterCompensation = function calculateGutterCompensation(gutter) {
  var toGutterCompensation = function toGutterCompensation(g) {
    if (g === null) {
      return null;
    }

    return -1 * (g / 2);
  };

  if (gutter === null) {
    return null;
  }

  if (!Array.isArray(gutter)) {
    return toGutterCompensation(gutter);
  } else {
    return gutter.map(toGutterCompensation);
  }
};

var calculateHalfGutterWidth = function calculateHalfGutterWidth(gutter) {
  var toHalfGutter = function toHalfGutter(g) {
    if (g === null) {
      return null;
    }

    return g / 2;
  };

  if (gutter === null) {
    return null;
  }

  if (!Array.isArray(gutter)) {
    return toHalfGutter(gutter);
  } else {
    return gutter.map(toHalfGutter);
  }
};

var toWidth = function toWidth(columnCount, totalColumns) {
  if (columnCount === null || totalColumns === null) {
    return null;
  }

  return "".concat(Math.min(totalColumns, columnCount) / totalColumns * 100, "%");
};

var calculateColumnWidth = function calculateColumnWidth(gridColumns, columns) {
  if (gridColumns === null || columns === null) {
    return null;
  }

  if (!Array.isArray(gridColumns) && !Array.isArray(columns)) {
    return toWidth(columns, gridColumns);
  }

  var gridColumnsArray = Array.isArray(gridColumns) ? gridColumns : [gridColumns];
  var columnsArray = Array.isArray(columns) ? columns : [columns];
  return _toConsumableArray(Array(Math.max(gridColumnsArray.length, columnsArray.length))).map(function (v, i) {
    var columns = typeof columnsArray[i] === 'undefined' ? columnsArray[columnsArray.length - 1] : columnsArray[i];
    var gridColumns = typeof gridColumnsArray[i] === 'undefined' ? gridColumnsArray[gridColumnsArray.length - 1] : gridColumnsArray[i];
    return toWidth(columns, gridColumns);
  });
};

var GridContext = /*#__PURE__*/React.createContext({
  columns: null,
  gutter: null
});
var ALIGN_MAP = {
  top: 'flex-start',
  bottom: 'flex-end',
  stretch: 'stretch',
  center: 'center'
};
var Row = styled(Box).attrs(function (_ref) {
  var $gutterCompensation = _ref.$gutterCompensation,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'top' : _ref$align,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as;
  return {
    as: as,
    $mx: $gutterCompensation,
    $styles: {
      display: 'flex',
      flex: '0 1 auto',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: ALIGN_MAP[align]
    }
  };
}).withConfig({
  displayName: "Grid__Row",
  componentId: "sc-ldxlam-0"
})([""]);

var Column = function Column(props) {
  var columns = props.columns,
      children = props.children,
      restProps = _objectWithoutProperties(props, _excluded);

  var gridSettings = useContext(GridContext);
  var halfGutterWidth = calculateHalfGutterWidth(gridSettings.gutter);
  var width = calculateColumnWidth(gridSettings.columns, columns || gridSettings.columns);
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    $px: halfGutterWidth,
    $styles: {
      flex: '0 0 auto',
      flexBasis: width,
      maxWidth: width
    }
  }, restProps), {}, {
    children: children
  }));
};

var Grid = function Grid(props) {
  var children = props.children,
      columns = props.columns,
      gutter = props.gutter,
      restProps = _objectWithoutProperties(props, _excluded2);

  var gutterCompensation = calculateGutterCompensation(gutter);
  return /*#__PURE__*/_jsx(GridContext.Provider, {
    value: {
      columns: columns,
      gutter: gutter
    },
    children: /*#__PURE__*/_jsx(Row, _objectSpread(_objectSpread({
      $gutterCompensation: gutterCompensation
    }, restProps), {}, {
      children: children
    }))
  });
};

export default Object.assign(Grid, {
  Column: Column
});